import { Component, Input } from '@angular/core';
import { MentionImportFileParameters, MentionImportParameters } from '../../../services/mention-csv-import-dialog.service';
import { AbstractDialogComponent } from '../../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-mention-import-confirm-dialog',
    templateUrl: './mention-import-confirmation.component.html',
    styleUrls: ['./mention-import-confirmation.component.scss'],
    standalone: false
})
export class MentionImportConfirmationComponent extends AbstractDialogComponent {

    @Input() files: File[];
    @Input() parameters: MentionImportParameters;
    @Input() fileParameters: MentionImportFileParameters;

    termsAccepted: boolean;
    isBusy: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(public coreDialogService: CoreDialogService) {
        super(coreDialogService, 'MentionImportConfirmation');
        this.termsAccepted = false;
    }

    importCsv(): void {
        this.isBusy = true;
        this.closeDialog(true);
    }
}
